enum UserType {
    SysAdmin				= "SysAdmin",
	Agency				    = "Agency",
	Company			        = "Company",
	Worker               = "Worker",
	Undefined               = ""
}

export default UserType;
